export default "__VITE_ASSET__a07c29d6__"